import "../../../styles/loader.css"
const Loading = () => {
    return(
        <div className="main-container-loader">
           <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    )
}

export default Loading
